<template>
  <button
    class="flex flex-row items-center justify-center gap-1 rounded-lg px-4 py-2 text-sm font-medium shadow-2xs transition-colors focus:ring-2 focus:outline-0"
    :class="{
      'bg-bluedark-600 ring-bluedark-100 hover:bg-bluedark-700 focus:border-bluedark-100 disabled:bg-bluedark-200 text-white':
        color === 'bluedark',
      'bg-gray-700 text-white ring-gray-100 hover:bg-gray-900 focus:border-gray-100 disabled:bg-gray-200':
        color === 'gray',
      'bg-error-600 ring-error-100 hover:bg-error-700 focus:border-error-100 disabled:bg-error-200 text-white':
        color === 'error',
      'bg-success-600 ring-success-100 hover:bg-success-700 focus:border-success-100 disabled:bg-success-200 text-white':
        color === 'success',
      'border border-gray-300 bg-white text-gray-900 hover:bg-gray-50 focus:ring-gray-200 active:bg-gray-100 disabled:opacity-50':
        color === 'white',
      'border-error-500 text-error-900 ring-error-50 hover:bg-error-50 active:bg-error-100 border bg-white disabled:opacity-50':
        color === 'white-error',
      'bg-bluedark-50 text-bluedark-700 hover:bg-bluedark-100 disabled:bg-bluedark-25 disabled:text-bluedark-300 focus:border-transparent focus:ring-0':
        color === 'blue-light',
      'text-bluedark-700 hover:bg-bluedark-50 disabled:bg-bluedark-25 disabled:text-bluedark-300 ring-primary-300 bg-white focus:border-transparent focus:ring-0':
        color === 'blue-transparent',
      'disabled:bg-gray-25 bg-white text-gray-700 hover:bg-gray-50 focus:border-transparent focus:ring-0 disabled:text-gray-400':
        color === 'gray-transparent',
      'bg-error-50 text-error-700 hover:bg-error-100 active:bg-error-200 disabled:bg-error-25 disabled:text-error-300 focus:border-transparent focus:ring-0':
        color === 'red-light',
      'disabled:bg-green-25 bg-green-50 text-green-700 hover:bg-green-50 focus:border-transparent focus:ring-0 disabled:text-green-300':
        color === 'green-light',
      'bg-primary-900 ring-primary-300 hover:bg-primary-700 text-white': color === 'primary',
      'bg-agentnoon-primary-700 text-white hover:opacity-90': color === 'agentnoon-primary',
      'bg-gray-200 text-gray-700 hover:bg-gray-300': color === 'gray-light'
    }"
  >
    <slot></slot>
    <Spinner v-if="isLoading" :color="loaderColor" />
  </button>
</template>

<script setup>
import Spinner from '@/components/SpinnerComp.vue'
import { computed } from 'vue'

const props = defineProps({
  isLoading: {
    type: Boolean,
    default: false
  },
  color: {
    type: String,
    default: 'bluedark',
    validator: (val) =>
      [
        'bluedark',
        'error',
        'white',
        'white-error',
        'blue-light',
        'green-light',
        'red-light',
        'success',
        'primary',
        'blue-transparent',
        'gray-transparent',
        'gray',
        'gray-light'
      ].includes(val)
  }
})

/**
 * Gets the color for the loader based on the provided props.
 *
 * @returns {string} The color to be used for the loader.
 */
const loaderColor = computed(() => {
  // If the provided color is 'error' or 'success', return that color.
  // Otherwise, return 'white' as the default color for the loader.
  return props.color === 'error' || props.color === 'success' ? props.color : 'white'
})
</script>
